import {
  type EmailRoutingDefinition,
  type EmailRoutingDefinitionJson,
  hydrateEmailRoutingDefinition,
} from '@utils/emailHostRouting';
import { isDev, isStaging } from '@utils/isProd';

import developmentRoutingJson from './developmentRoutingJson';
import productionRoutingJson from './emailRouting.production.json';
import stagingRoutingJson from './emailRouting.staging.json';

let developmentDefinition: EmailRoutingDefinition | null = null;
let stagingDefinition: EmailRoutingDefinition | null = null;
let productionDefinition: EmailRoutingDefinition | null = null;

export function getEmailRoutingDefinition(): EmailRoutingDefinition {
  if (isStaging()) {
    if (!stagingDefinition) {
      stagingDefinition = hydrateEmailRoutingDefinition(
        stagingRoutingJson as EmailRoutingDefinitionJson
      );
    }
    return stagingDefinition;
  }
  if (isDev()) {
    if (!developmentDefinition) {
      developmentDefinition = hydrateEmailRoutingDefinition(
        developmentRoutingJson as EmailRoutingDefinitionJson
      );
    }
    return developmentDefinition;
  }
  if (!productionDefinition) {
    productionDefinition = hydrateEmailRoutingDefinition(
      productionRoutingJson as EmailRoutingDefinitionJson
    );
  }
  return productionDefinition;
}
